import { createFileRoute } from "@tanstack/react-router";
import { StudioCandidaturePage } from "@/views/public/studios/StudioCandidaturePage.tsx";

export const Route = createFileRoute("/_public/studios/$number/candidature")({
  component: StudioCandidaturePage,
});
